// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","container":"App_container__Rt8T2"};